import { DateTime } from 'luxon';

export default function (dateString) {
    if (dateString === undefined || dateString === null || dateString === '') {
        return '';
    }

    if (dateString instanceof DateTime) {
        return dateString;
    }

    return DateTime.fromISO(dateString);
}
